import { useBreakpoint } from '@vivaldis/antd-ui'
import { NavigationMenu } from '../../../../components/NavigationMenu'

interface Props {
  isSiderCollapsed: boolean
}

export const LeftNavigationMenu = ({ isSiderCollapsed }: Props) => {
  const breakpoint = useBreakpoint()

  // no navigation bar on mobile
  if (!breakpoint.md) {
    return null
  }

  return <NavigationMenu isSiderCollapsed={isSiderCollapsed} />
}
